module.exports = __webpack_public_path__ + "img/horizontal_3_1_8019.a85ff511.png";